<template>
  <div class="p-contentplans-writing-ai-phase">
    <Advice v-if="isLoading" img="pencil" priority="low-gray">
      <p>
        ユーザーの検索意図と記事のゴールを基に、見出し構成案・ディスクリプションを考えています<span
          class="c-loading-dots"
        ></span>
      </p>
    </Advice>
    <template v-else>
      <Advice img="pencil" priority="low-gray">
        <p v-if="isErrorHeadings">
          調査したキーワードはChat
          API(GPT-3.5)のポリシーに反する内容だったため、AIからの回答を受け取れませんでした。<br />お手数ですが、画面右「見出し構成案」をご検討ください。
        </p>
        <div v-else class="c-text--free">
          <p>理想的な見出し構成案は以下の通りです。</p>
          <ul class="p-contentplans-writing-ai-headings-list c-list--disc">
            <li
              v-for="item in aiHeadingsData.items"
              :key="item.id"
              :class="'p-contentplans-writing-ai-headings-item--' + item.level"
            >
              {{ item.value }}
            </li>
          </ul>
        </div>
      </Advice>
      <Advice img="pencil" priority="low-gray">
        <p v-if="isErrorDescription">
          調査したキーワードはChat
          API(GPT-3.5)のポリシーに反する内容だったため、AIからの回答を受け取れませんでした。<br />お手数ですが、画面右「ディスクリプション案」をご検討ください。
        </p>
        <div v-else class="c-text--free">
          <p>理想的なディスクリプション案は以下の通りです。</p>
          <p v-for="item in aiDescriptionData.items" :key="item">
            <span class="c-text--prewrap">{{ item }}</span>
          </p>
        </div>
      </Advice>
      <div class="p-contentplans-writing-ai-phase__buttons">
        <div class="c-alertPos">
          <ButtonRectangle
            v-if="isError"
            priority="high"
            :isLoading="isProcessing"
            :disabled="isDisabledInputButton"
            @click="submitInput"
            >記入して次へ</ButtonRectangle
          >
          <ButtonRectangle
            v-else
            priority="high"
            :isLoading="isProcessing"
            :disabled="isDisabledCopyButton"
            @click="submitCopy"
            >反映して次へ</ButtonRectangle
          >
          <Alert v-if="error">{{ error }}</Alert>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Advice from '@/components/Advice';
import Alert from '@/components/Alert';
import ButtonRectangle from '@/components/ButtonRectangle';

export default {
  props: {
    aiDescriptionData: {
      type: Object,
      required: false,
      default: null
    },
    aiHeadingsData: {
      type: Object,
      required: false,
      default: null
    },
    error: {
      type: String,
      required: true
    },
    userDescription: {
      type: String,
      required: true
    },
    userHeadings: {
      type: Array,
      required: true
    },
    isCurrent: {
      type: Boolean,
      required: true
    },
    isDisabled: {
      type: Boolean,
      required: true
    },
    isEditMode: {
      type: Boolean,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isProcessing: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Advice,
    Alert,
    ButtonRectangle
  },
  computed: {
    isDisabledCopyButton() {
      // 別のフェーズ、送信中の場合はtrue
      return !this.isEditMode ||
        this.isDisabled ||
        !this.isCurrent ||
        this.isProcessing
        ? true
        : false;
    },
    isDisabledInputButton() {
      // 別のフェーズ、送信中、入力中の場合はtrue
      return !this.isEditMode ||
        this.isDisabled ||
        !this.isCurrent ||
        this.isProcessing ||
        (this.isErrorDescription && !this.userDescription) ||
        (this.isErrorHeadings && !this.userHeadings.some(h => h.value))
        ? true
        : false;
    },
    isError() {
      return this.isErrorHeadings && this.isErrorDescription;
    },
    isErrorHeadings() {
      // dataがnull、またはitemsが空の場合はtrue
      return !this.aiHeadingsData ||
        !this.aiHeadingsData.items ||
        !this.aiHeadingsData.items.length
        ? true
        : false;
    },
    isErrorDescription() {
      return !this.aiDescriptionData ||
        !this.aiDescriptionData.items ||
        !this.aiDescriptionData.items.length
        ? true
        : false;
    }
  },
  methods: {
    submit() {
      this.$emit('submit', !this.isErrorDescription, !this.isErrorHeadings);
    },
    submitCopy() {
      if (this.isDisabledCopyButton) {
        return;
      }
      this.submit();
    },
    submitInput() {
      if (this.isDisabledInputButton) {
        return;
      }
      this.submit();
    }
  }
};
</script>
